<template>
  <div class="container">
    <h1 class="py-4">パートナー管理</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="l-partnerName">パートナー名</label><br />
          <input
            v-model="partnerName"
            placeholder="パートナー名"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="l-type">業種</label><br />
          <select v-model="type" class="input-boot">
            <option disabled value="">業種</option>
            <option
              v-for="option in this.industries"
              :value="option.value"
              :key="option.value"
            >
              {{ option.display }}
            </option>
          </select>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">
          クリア
        </button>
        <button class="btn btn-primary mr10" @click="search">
          検索
        </button>
      </div>
      <div class="text-left">
        <button class="btn btn-primary" @click="redirectCreate">
          新規登録
        </button>
      </div>
    </div>
    <div>
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="userTable"
          :items="partners"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(パートナー名)="data">
            <router-link
              :to="{
                name: 'PartnerDetails',
                query: { pid: data.item.PID },
              }"
              >{{ data.item.パートナー名 }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="userTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import master from "@/constants/MasterEnum";

export default {
  name: "Partners",
  mixins: [master],
  computed: {
    rows() {
      return this.partners.length;
    },
  },
  data() {
    return {
      db: firebase.firestore(),
      previewImage: null,
      loading: true,
      currentPage: 1,
      perPage: 20,
      partnerName: "",
      type: "",
      imageName: "",
      url: "",
      pid: "",
      partners: [],
      file: null,
    };
  },
  created: function() {
    this.loadPartners();
  },
  methods: {
    redirectCreate() {
      this.$router.push({
        name: "CreatePartner",
      });
    },
    clear() {
      this.partnerName = "";
      this.type = "";
      this.loadPartners();
    },
    search() {
      let searchParams = {
        partnerName: this.partnerName,
        type: this.type,
      };
      this.loadPartners(searchParams);
    },
    async loadPartners(searchParams = null) {
      this.loading = true;
      this.partners = [];
      let query = this.db.collection("partners");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      if (searchParams == null) {
        query = query.orderBy("type", "asc");
      }
      const snapshot = await query.get();
      snapshot.forEach((doc) => {
        let data = doc.data();
        let tableData = {
          パートナー名: data.partnerName,
          PID: data.pid,
          URL: data.url,
        };
        try {
          tableData.業種 = this.industries.find(
            (element) => element.value == data.type
          ).display;
        } catch (error) {
          tableData.業種 = data.type;
        }
        this.partners.push(tableData);
      });
      this.loading = false;
    },
    async createPartner() {
      if (
        this.pid !== "" &&
        this.url !== "" &&
        this.type !== "" &&
        this.partnerName !== "" &&
        this.imageName !== "" &&
        this.file !== null
      ) {
        // upload picture get url from storage and add document to collection
        let storageRef = firebase.storage().ref();
        let imageRef = storageRef.child("partners/" + this.imageName);
        let doc = {
          partnerName: this.partnerName,
          pid: this.pid,
          url: this.url,
          type: this.type,
        };
        await imageRef.put(this.file);
        let imageUrl = await imageRef.getDownloadURL();
        doc.imageUrl = imageUrl;
        let partnerRef = this.db.collection("partners").doc();
        await partnerRef.set(doc);
        this.loadPartners();
      } else {
        //console.log("missing arguments");
      }
    },
    imageSelected(e) {
      const file = e.target.files[0];
      if (file !== undefined) {
        let fileNameSplit = file.name.split(".");
        let fileFormat = fileNameSplit[fileNameSplit.length - 1];
        if (
          fileFormat == "jpg" ||
          fileFormat == "jpeg" ||
          fileFormat == "png"
        ) {
          this.imageName = file.name;
          this.file = file;
          this.previewImage = URL.createObjectURL(file);
        } else {
          this.file = null;
          this.previewImage = null;
        }
      } else {
        this.previewImage = null;
        this.file = null;
      }
    },
  },
};
</script>
